import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {AdvertisementService_GetSponsoredSectionsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/advertisement/service.grpc.lazy';
import {GetSponsoredSectionsRequest_TargetType} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/advertisement/service.types';
import {useOptionalSession} from '@aboutyou/user';
import {useTargetGroupIdentifier} from '../../shared-deprecated/useTargetGroupIdentifier';

export const useGetSearchSuggestCampaignsRequest = () => {
  const session = useOptionalSession();

  return useGrpcRequest(
    AdvertisementService_GetSponsoredSectionsLazy,
    {
      session,
      targetType: GetSponsoredSectionsRequest_TargetType.SEARCH_SUGGESTION,
      targetGroup: useTargetGroupIdentifier(),
    },
    {
      disabled: !session,
    },
  );
};
